import { useMutation } from "react-query";

import { feeTemplateService } from "services";

type GetTemplateMutationProps = {
	companyId: string;
	templateId: number;
};

const useGetFeeTemplateMutation = () => {
	return useMutation(
		({ companyId, templateId }: GetTemplateMutationProps) =>
			feeTemplateService.getTemplate(companyId, templateId),
		{
			retry: 0,
		},
	);
};

export default useGetFeeTemplateMutation;
